// extracted by mini-css-extract-plugin
export default {"tabBtn":"tabButton_tabBtn__CFS7U","parentPrimaryBg":"tabButton_parentPrimaryBg__Z5Agb","active":"tabButton_active__Bzk10"};